<!--横向滑动包裹类  -->
<template>
    <div class="SelectButton">

        <RButton v-for="(item,ix) in list" :color="item.select?'ghost':'default'" :key="`select-btn-it-${ix}`"
                 @on-click="()=>onSelect(item.id,item.name,item.value,item.select)">{{item.name}}
        </RButton>

    </div>
</template>


<script>

    import RButton from "../Use/r-button";

    export default {
        name: "SelectButton",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            }

        },
        data() {
            return {};

        },
        methods: {
            onSelect(id, name, value,select) {
                this.$emit("on-select", name, value, id,'','',select);
            }

        }
    };
</script>
<style lang="less" scoped>
    .SelectButton {
        display: flex;
        flex-wrap: wrap;



    }

</style>
